import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';


class Sidebar extends Component {

   constructor(props) {
    super(props);

     this.state={

     }
  }
  render() {
    const _this=this;

    return (

        <div className="sidebar" data-color="azure" data-background-color="white" data-image="/img/sidebar-1.jpg">

      <div className="logo">
        <Link to="#" className="simple-text logo-normal text-center">
          TUC - STUDENT PORTAL
        </Link>
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav">
          <li className="nav-item">
            <NavLink className="nav-link" to="/student_ui/dashboard">
              <i className="material-icons">person</i>
              <p>My Profile</p>
            </NavLink>
          </li>
          <li className="nav-item ">
            <NavLink className="nav-link" to="/student_ui/academics">
              <i className="material-icons">school</i>
              <p>Academics</p>
            </NavLink>
          </li>
          <li className="nav-item ">
            <NavLink className="nav-link" to="/student_ui/finance">
              <i className="material-icons">monetization_on</i>
              <p>Finance</p>
            </NavLink>
          </li>
        </ul>
      </div>
    <div className="sidebar-background"></div></div>





    );
  }




}

export default Sidebar;
